import { render, staticRenderFns } from "./TouristicEditor.vue?vue&type=template&id=5192214f"
import script from "./TouristicEditor.vue?vue&type=script&lang=js"
export * from "./TouristicEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports